import {
  list,
  changeStatus,
  getStatus,
  refresh,
  protectAll,
  unprotectAll,
  backupAll,
  backupAllActiveSeats,
  exportSnapshot,
  listOrganizationlUnits,
  getStatusOrgUnits
} from "@/services/api/app/google/seat-management/user";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  users: [],
  orgUnits: [],
  orgUnitPath: '',
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  filter: {
    statuses: null,
  },
  status: null,
  statusOrgUnitPath: null
});

export default {
  namespaced: true,

  actions: {
    list({commit, state},) {
      return list({
        pagination: state.pagination,
        filter: {
          statuses: state.filter.statuses
        },
        orgUnitPath: state.orgUnitPath,
        search: state.search
      })
        .then(({result, pagination}) => {
          const users = result.reduce((acc, user) => {
            return [
              ...acc,
              {
                ...user,
                totalSize: user.size.calendarSize + user.size.contactsSize + user.size.driveSize + user.size.mailSize
              }
            ]
          }, [])

          commit('setUsers', users)
          commit('setPagination', pagination)
        })
    },
    getOrgUnits({ commit }) {
      return listOrganizationlUnits()
        .then(units => {
          console.log('units', units.result)
          commit("setOrgUnits", units.result)
        })
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    refresh({commit}) {
      return refresh()
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    backupAll() {
      return backupAll()
    },
    backupAllActiveSeats({ state }) {
      return backupAllActiveSeats(state.orgUnitPath);
    },
    getStatusOrgUnits ({ state, commit }) {
      return getStatusOrgUnits({ orgUnitPath: state.orgUnitPath })
        .then(res => {
          commit('setStatusOrgUnits', res);
          return res;
        });
    },
    protectAll({ state }) {
      return protectAll({ orgUnitPath: state.orgUnitPath });
    },
    unprotectAll({ state }) {
      return unprotectAll({ orgUnitPath: state.orgUnitPath });
    },
    exportSnapshot({commit, state}, {filter, search, pagination}) {
      return exportSnapshot(filter, search, pagination)
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setOrgUnitPath(state, unitPath) {
      state.orgUnitPath = unitPath;
    },
    setOrgUnits(state, units) {
      state.orgUnits = units;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatus(state, status) {
      state.status = status
    },
    setStatusOrgUnits(state, statusOrgUnits) {
      state.statusOrgUnitPath = statusOrgUnits
    },
    setUserStatus(state, {user, status}) {
      state.users = state.users.map(u => {
        if (u.userId === user.userId) {
          return {
            ...u,
            status: status.value
          }
        }

        return u;
      })
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },


  state: defaultState()
}
